import { render, staticRenderFns } from "./allocation_window_statuses.vue?vue&type=template&id=0d075b4e&scoped=true&"
import script from "./allocation_window_statuses.vue?vue&type=script&lang=js&"
export * from "./allocation_window_statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d075b4e",
  null
  
)

export default component.exports